import { ApiEntity} from "../../Api/api.model";
import { string, type, array, boolean, nullable} from "superstruct";
import { validateStruct } from "../../../utils/validate";
import { coerceTags, extractLocker } from "../../serviceUtils";
import { MediaAsset, MediaAssetStruct } from "../../../utils/assets";
export interface Chapter {
  id: string;
  index: string;
  name: string;
  tags: Array<string>;
  introImg: MediaAsset;
  coverImg: MediaAsset;
  challenges: Array<string>;
  title: string;
  description: string;
  lock:{
    locked:boolean;
    lockerId?:string;
  }
}

function extractChallengeIds(blogs: Array<{ id: string }>): Array<string> {
  return blogs.map((blog) => blog.id.toString());
}

const ChapterStruct = type({
  id: string(),
  index: string(),
  name: string(),
  tags: array(string()),
  introImg: MediaAssetStruct,
  coverImg: MediaAssetStruct,
  challenges: array(string()),
  title: string(),
  description: string(),
  lock:type({
    locked:boolean(),
    lockerId:nullable(string())
  })
});
export class ChapterEntity extends ApiEntity<Array<Chapter>> {
  constructor() {
    super("chapters");
  }
  validate(rawData: Array<{}>): Array<Chapter> {
    return rawData.map((rawItem) =>
      validateStruct<Chapter>(rawItem, ChapterStruct,this.endPoint, [
        { field: "tags", transform: coerceTags },
        { field: "challenges", transform: extractChallengeIds },
        { field: "lock", transform: extractLocker},{field:'id',transform:(id:number) => id.toString() }
      ])
    );
  }
}
